/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { updateOptionProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import AnswerText2 from 'material/embeds/content/shared/answer/text2/text2';



/* ========== ~~~~~~~~~~ EMBED : ANSWER : TEXT 2 : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId, optionId }) => ({
    isValid: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['isValid'],
    text: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['text'],
    isDuplicate: embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options'][optionId]['isDuplicate']
});

const mapDispatchToProps = dispatch => ({
    updateOptionProperty: (contentId, optionId, propertyName, value) => dispatch(updateOptionProperty(contentId, optionId, propertyName, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnswerText2);
